import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import StatsCard from "../components/StatsCard";
import "./Dashboard.css";

const Dashboard = ({ auth, onLogout }) => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/stats`, {
      headers: {
        Authorization: "Basic " + btoa(`${auth.username}:${auth.password}`),
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Unauthorized");
        return res.json();
      })
      .then(setStats)
      .catch(() => setError("Access denied or API error"));
  }, [auth]);

  if (error) return <div className="error">{error}</div>;
  if (!stats) return <div className="loading">Loading...</div>;

  const labels = {
    total_users: "Total Users",
    weekly_active_users: "Weekly Active Users",
    new_users_24h: "New Users (24h)",
    total_posts: "Total Post Generations",
    total_hooks: "Total Hook Generations",
    total_video_downloads: "Total Video Downloads",
    total_headlines: "Total Headline Generations",
    total_summaries: "Total Summary Generations",
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">Brandly Admin Panel</h1>
        <button className="logout-btn" onClick={onLogout}>Logout</button>
      </div>
      <div className="stats-grid">
        {Object.entries(stats).map(([key, value], index) => (
          <motion.div
            key={key}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <StatsCard label={labels[key]} value={value} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
